export const getColorForMenuId = (() => {
  const generateRandomColor = () => {
    return `#${Math.floor(Math.random() * 16777215)
      .toString(16)
      .padStart(6, "0")}`;
  };

  const menuIdColorMap = new Map();

  return (menu_id) => {
    if (!menuIdColorMap.has(menu_id)) {
      let color;
      do {
        color = generateRandomColor();
      } while ([...menuIdColorMap.values()].includes(color));

      menuIdColorMap.set(menu_id, color);
    }
    return menuIdColorMap.get(menu_id);
  };
})();

export const renderIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    className="bi bi-list"
    viewBox="0 0 16 16"
  >
    <path
      fillRule="evenodd"
      d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5"
    />
  </svg>
);
